import React from "react";
import { SvgIcon } from "@mui/material";
import { svgs } from "assets";


export const SurveyHeroIcon = () => (
  <SvgIcon
    sx={{
      width: "60%",
      height: "60%",
    }}
    component={svgs.SURVEY_HERO_SVG}
    inheritViewBox />
);
